import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { has, t } from 'Src/i18n';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Text } from 'Components/frameworks/text/Text';
import { TextLink } from 'Components/frameworks/text-link/TextLink';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  status: GreatMembersStatus;
};
export const GreatMembersAccordionContent = ({ status }: Props) => {
  const links = ['downloadAdvantages', 'seeConditions'];
  const bulletPoints = [...new Array(10)]
    .map((_, i) =>
      has(`customerAccount.greatMember.stasusesSection.tabs.${status}.bulletPoints.${i}.title`)
        ? {
            description: t(
              `customerAccount.greatMember.stasusesSection.tabs.${status}.bulletPoints.${i}.description`,
            ),
            linkLabel: t(
              `customerAccount.greatMember.stasusesSection.tabs.${status}.bulletPoints.${i}.link.label`,
            ),
            linkUrl: t(
              `customerAccount.greatMember.stasusesSection.tabs.${status}.bulletPoints.${i}.link.url`,
            ),
            title: t(
              `customerAccount.greatMember.stasusesSection.tabs.${status}.bulletPoints.${i}.title`,
            ),
          }
        : null,
    )
    .filter(Boolean);
  return (
    <div className="py-20 sm:flex md:py-40">
      <div className="flex justify-center sm:w-1/2">
        <div className={`py-20 text-center text-12 sm:pb-0 sm:pt-60 sm:text-16 text-gm-${status}`}>
          <Icon
            className="text-black"
            isNotMonoChrome
            isNotSquare
            name={ICONS[`CLUBMED_GREAT_MEMBERS_${status.toUpperCase()}`]}
            width="20em"
          />
          <div
            className="mt-5 text-14 sm:text-16"
            data-testid="GreatMembersAccordionContent-pointsNeeded"
          >
            {t(`customerAccount.greatMember.stasusesSection.tabs.${status}.pointsToReachStatus`)}
          </div>
        </div>
      </div>
      <div className="sm:w-1/2">
        <Title hLevel={2} theme="title-brand-n2">
          {t(`customerAccount.greatMember.stasusesSection.tabs.${status}.title`)}
        </Title>
        <Title className={`text-${status}`} hLevel={3} theme="title-sans-n2">
          {t(`customerAccount.greatMember.stasusesSection.tabs.${status}.subtitle`)}
        </Title>
        <Text
          className="my-20"
          text={t(`customerAccount.greatMember.stasusesSection.tabs.${status}.description`)}
        />
        {bulletPoints.map((b) => (
          <div className="relative pb-20 ps-25" key={b.title}>
            <span
              className={`absolute start-0 mt-5 text-32 font-bold leading-0 text-gm-${status} top-[3px]`}
            >
              •
            </span>
            <span className={`font-bold text-gm-${status}`}>{b.title}</span>
            <Text text={b.description} />
            <TextLink label={b.linkLabel} target="_blank" url={b.linkUrl} />
          </div>
        ))}
        {links.map((link) => (
          <div
            className="mt-10 text-end"
            data-testid="GreatMembersAccordionContent-links"
            key={link}
          >
            <TextLink
              className="underline"
              iconName={ICONS.ARROW_TAIL_RIGHT}
              label={t(`customerAccount.greatMember.stasusesSection.tabs.links.${link}.label`)}
              target="_blank"
              url={t(`customerAccount.greatMember.stasusesSection.tabs.links.${link}.url`)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
